// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a29d440b","453":"8725a586","455":"0ae09095","977":"56741800"}[chunkId] + ".chunk.js";
};